import * as axios from 'axios';
import * as utils from '../shared/service-utils';

import { API } from '../shared/config';

export default {
  methods: {
    async getTaxFilingDetailsForPP(userId) {
      try {
        const hdr = await utils.getAuthHeader();
        const response = await axios.get(`${API}/tax-filings/details/${userId}`, { headers: hdr });
        // console.log('getTaxFilingDetailsForPP:', JSON.stringify(response.data));
        return response.data;
      } catch (error) {
        console.error(error);
        return {};
      }
    },
  },
};
